import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import _ from 'lodash';
import classnames from 'classnames/bind';
import {IBreadCrumb, IState, Replacement} from '../../../interface';
import style from './index.module.scss';
import {connect} from 'react-redux';
import localesReplacement from '../../../utils/localesReplacement';
import UndirectLink from '../../UndirectLink';

const cx = classnames.bind(style);

export interface IProps {
  dataList: IBreadCrumb[];
  replacements: Replacement;
}

//breadcrumb component
function Breadcrumb(props: IProps) {
  const {dataList, replacements} = props;
  const navigation = useNavigate();
  return (
    <div className={`breadcrumb ${cx('breadcrumb')}`}>
      <ul>
        {_.map(dataList, (o, i) =>
          o.href ? (
            <li key={i}>
              {_.isEqual(o['href'], '#') ? (
                <UndirectLink>
                  {localesReplacement(replacements, o['value'])}
                </UndirectLink>
              ) : _.isEqual(o['href'], '-1') ? (
                <UndirectLink onClick={() => navigation(-1)}>
                  {localesReplacement(replacements, o['value'])}
                </UndirectLink>
              ) : (
                <Link to={o['href']}>
                  {localesReplacement(replacements, o['value'])}
                </Link>
              )}
            </li>
          ) : (
            <li key={i}>
              <span>
                {o['static']
                  ? localesReplacement(replacements, o['value'])
                  : o['value']}
              </span>
            </li>
          ),
        )}
      </ul>
    </div>
  );
}

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(Breadcrumb);
